import { Grid } from "@mui/material";
import { ProviderGroupDetails } from "../../types/provider-types";
import Flex from "../Flex";
import Text from "../Text";
import CustomTitle from "./CustomTitle";
import {
  DEFAULT_PROVIDER_GROUP_IMG_SRC,
  getAddressFormat,
} from "../../utils/utils";
import MultiSpecialty from "../MultiSpecialty";

const ProviderGroupProfileDetailCard = ({
  profileData,
}: {
  profileData?: ProviderGroupDetails;
}) => {
  return (
    <Flex
      border={"1px solid #1A1A1A33"}
      borderRadius={"10px"}
      padding={2}
      minHeight={75}
      height={"100%"}
      gap={"20px"}
    >
      <img
        style={{ borderRadius: 5 }}
        src={profileData?.avatar ?? DEFAULT_PROVIDER_GROUP_IMG_SRC}
        width={"75px"}
        height={"75px"}
      />
      <Flex flex={1} flexWrap={"wrap"}>
        <Grid container>
          <StyledPairName
            name={profileData?.name}
            speciality={profileData?.specialities}
          />
          <StyledPairValues k="Contact Number" val={profileData?.phone} />
          <StyledPairValues k="Website" val={profileData?.website} />
          <StyledPairValues
            k="Group Npi Number"
            val={profileData?.npi}
            reduceWidth={(profileData?.name?.length ?? 0) > 12}
          />
          <StyledPairValues k="Email" val={profileData?.email} />
          <StyledPairValues
            k="Physical Address"
            val={getAddressFormat(profileData?.physicalAddress)}
          />
        </Grid>
      </Flex>
    </Flex>
  );
};

export default ProviderGroupProfileDetailCard;

interface StylePairValuesProps {
  k: string;
  val?: string;
  reduceWidth?: boolean;
}
const StyledPairValues = ({ k, val, reduceWidth }: StylePairValuesProps) => {
  return (
    <Grid container item xs={12} sm={6} lg={4} key={k}>
      <Grid
        item
        xs={4}
        sm={3}
        md={5}
        lg={k === "Group Npi Number" ? (reduceWidth ? 7 : 5) : 3.4}
      >
        <Text fontWeight={"medium"} color={"#1A1A1A80"}>
          {k}
        </Text>
      </Grid>
      <Grid
        item
        xs={6}
        sm={7}
        md={7}
        lg={k === "Group Npi Number" ? (reduceWidth ? 5 : 7) : 8.2}
      >
        <Text>{val || "-"}</Text>
      </Grid>
    </Grid>
  );
};

interface StyledPairProps {
  name?: string;
  speciality?: Record<string, string>;
}
const StyledPairName = ({ name, speciality }: StyledPairProps) => {
  return (
    <Grid container item xs={12} sm={12} md={4} lg={4} key={name}>
      <Grid item xs={6} sm={4} lg={(name?.length ?? 0) > 12 ? 7 : 5}>
        <CustomTitle color={"black"} bold variant="h5" mb={"14px"}>
          {name}
        </CustomTitle>
      </Grid>
      <Grid item xs={6} sm={7} md={8} lg={(name?.length ?? 0) > 12 ? 5 : 7}>
        <MultiSpecialty specialties={speciality} width={280} />
      </Grid>
    </Grid>
  );
};
